import React from 'react';
import styles from './FilePreview.module.scss';
import closeSvg from '../assets/close.svg';
import Loader from 'component/atom/loader/Loader';
import defaultDoc from '../assets/default-doc.svg';
const FilePreview = ({ file, isLoading = true, handleChange }) => {
  const handleClear = () => {
    handleChange(null);
  };
  return (
    <div className={styles['file-preview']}>
      <img
        className={styles['svg']}
        src={closeSvg}
        alt=""
        onClick={handleClear}
      />
      <div className={styles['file-view']}>
        <img className={styles['image']} src={defaultDoc} alt="" />
        <div className={styles['file-details']}>
          <h3>{file?.file?.name}</h3>
          <p>{file?.file?.type}</p>
        </div>
      </div>
    </div>
  );
};

export default FilePreview;
